/**
 * Top Banner 컴포넌트
 * --
 */
import React, { useState } from 'react';
import './TopBanner.style.css';
import { CloseOutlined } from '@ant-design/icons';
import { setStorage } from 'utils';

const TopBanner = ({
  children,
  maxWidth = 1060,
  height = 35,
  backgroundColor = '#111111',
  color = '#FFFFFF',
  padding = null,
  align = 'center',
  icon = <CloseOutlined />,
  iconStyle = {},
  isShow = true,
  onClick = null,
  closable = true,
}) => {
  /* ===== State ===== */
  const [isOpened, setIsOpened] = useState(isShow);

  /* ===== Function ===== */
  /**
   * 탑 배너 숨김처리
   * --
   */
  const handleClose = () => {
    const today = new Date();
    setStorage('top_banner_hide', today.toISOString());
    setIsOpened(!isOpened);
  };

  if (!isShow) return null;

  /* ===== Render ===== */
  return (
    <div
      className="top_banner_layout"
      style={{
        backgroundColor: backgroundColor,
        padding: padding,
        height: isOpened ? height : 0,
        cursor: onClick ? 'pointer' : 'default',
      }}
      onClick={onClick ? () => onClick() : () => {}}
    >
      <div
        className="top_banner_container"
        style={{ maxWidth: maxWidth, color: color, textAlign: align }}
      >
        <div className="top_banner_content">{children}</div>
        {closable ? (
          <button
            className="top_banner_close_button"
            style={{ color: color, ...iconStyle }}
            onClick={() => handleClose()}
          >
            {icon}
          </button>
        ) : null}
      </div>
    </div>
  );
};

export default TopBanner;
